import React, {memo} from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import {useChipStyles} from "./chipStyles";

const StateChip = memo(({state}) => {
  const {classes} = useChipStyles();
  switch (state) {
    case "Draft":
      return <Chip label="Draft" color="primary" size="small" />;
    case "Active":
      return <Chip label="Active" size="small" className={classes.activeStateChip} />;
    case "Review":
      return <Chip label="Review" color="secondary" size="small" />;
    case "Hold":
      return <Chip label="Hold" color="error" size="small" />;
    case "Closed":
      return <Chip label="Closed" size="small" />;
    default:
      return null;
  }
});

StateChip.displayName = "StateChip";

StateChip.propTypes = {
  state: PropTypes.string,
};

export default StateChip;
